import { useLang } from "@/lib/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div
      className="marquee overflow-hidden border-y border-line bg-brand py-5 text-white"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 text-sm font-medium uppercase tracking-[0.2em] sm:text-base">{item}</span>
            <span className="block h-1.5 w-1.5 rounded-full bg-coral" />
          </span>
        ))}
      </div>
    </div>
  );
};
